export const registerSetupPageTranslations = {
    en: {

        valid_height_required: "Valid height is required",
        valid_weight_required: "Valid weight is required",
        valid_reach_required: "Valid reach is required",
        mainProfileImageTitle: 'Displays your main profile image visible to other users.',
        mainProfileImageDescription: 'A clear, professional photo helps build trust and recognition.',

        fightRecordTitle: 'Displays your fight record — wins, losses, and draws — in official or semi-official matches.',
        fightRecordDescription: 'Useful for credibility, matchmaking, and showcasing experience.',

        keyVideoTitle: 'Displays a key video that represents you — such as a fight highlight, promo, or introduction.',
        keyVideoDescription: 'Used to showcase your style, skills, or personality.',

        youtubeLinksTitle: 'Add links to your YouTube videos.',
        youtubeLinksDescription: 'This allows others to view your uploaded content directly from your profile.',

        sponsorsTitle: 'Showcase your sponsors.',
        sponsorsDescription: 'Adding sponsor details highlights the brands that support you and increases visibility for them.',

        socialMediaPublic: 'Shows your public social media profiles.',
        socialMediaDescription: 'Helps others connect with you, see your activity, and verify your presence in the combat sports world.',
        welcome: {
            title: "Your journey begins",
            subtitle: "Select your role to continue",
        },
        successModal: {
            title: "Registration successful",
            messageActive: "Your account was registered successfully.",
            messageInactive: "Your account was registered successfully. Also, your account is in an inactive state, contact your admin to activate your account.",

        },
        journey: {
            title: "Your Journey Begins",
            roleSelection: "Choose your role to get started.",
            personalDetails: "Provide your personal details to start building your profile.",
            locationDetails: "Specify your location details for a complete profile.",
            contactDetails: "Add your contact information to stay connected.",
            profileImageUpload: "Upload a profile image to personalize your account.",
            fighterForm: "Complete your fighter details to showcase your skills.",
            fightHistory: "Add your fight history to highlight your experience (optional).",
            managerForm: "Complete your manager details to start building your organization.",
            videoUpload: "Upload a video and YouTube links to highlight your skills.",
        },
        roles: {
            fighter: {
                title: "Fighter",
                description: "Create your fighter profile and showcase your skills",
            },
            manager: {
                title: "Manager",
                description: "Manage fighters and build your organization",
            },
            organization: {
                title: "Organization",
                description: "Complete organization management platform",
            },
        },
        personalDetails: {
            title: "Personal Details",
            subtitle: "Enter your personal information",
            firstName: "First Name",
            firstNamePlaceholder: "Enter first name",
            lastName: "Last Name",
            lastNamePlaceholder: "Enter last name",
            nickname: "Nickname",
            nicknamePlaceholder: "Enter nickname",
            dateOfBirth: "Date of Birth",
            gender: "Gender",
            genderPlaceholder: "Select your gender",
            male: "Male",
            female: "Female",
            other: "Other"
        },
        locationDetails: {
            title: "Location Details",
            subtitle: "Select your country and region",
            nationality: "Nationality",
            nationalityPlaceholder: "Select nationality",
            country: "Residence Country",
            countryPlaceholder: "Select country",
            region: "Region",
            regionPlaceholder: "Select region",
        },
        contactDetails: {
            title: "Contact Details",
            subtitle: "Provide your contact information",
            email: "Email",
            emailPlaceholder: "Enter email",
            phone: "Phone",
            phonePlaceholder: "Enter phone number",
            bio: "Bio",
            bioPlaceholder: "Enter bio (max 1000 characters)",
            socialMediaLinks: "Social Media Links (Optional)",
            addSocialMediaLink: "Add Social Media Link",
            removeSocialMediaLink: "Remove Link",
            socialMediaPlatform: "Social Media Platform",
            socialMediaPlatformPlaceholder: "Select platform",
            socialMediaUrl: "URL",
            socialMediaUrlPlaceholder: "Enter URL",
        },
        profileImageUpload: {
            title: "Profile Image",
            subtitle: "Upload or update your profile photo",
            uploadLabel: "Upload Profile Image",
            uploadDescription: "PNG, JPG (max 2MB)",
            viewFullImage: "View Full Image",
        },
        fighterFormBasic: {
            title: "Fighter Profile Basic Details",
            subtitle: "Enter your basic fighter metrics",
            height: "Height",
            heightPlaceholder: "Enter height",
            heightUnit: "Unit",
            weight: "Weight",
            weightPlaceholder: "Enter weight",
            weightUnit: "Unit",
            reach: "Reach",
            reachPlaceholder: "Enter reach",
            reachUnit: "Unit",
            stance: "Stance",
            stancePlaceholder: "Select stance",
            titleHolder: "Title Holder",
            yes: "Yes",
            no: "No",
            trainingDisciplines: "Competing in disciplines",
            trainingDisciplinesPlaceholder: "Select competing in disciplines",
            weightClasses: "Weight Classes",
            weightClassesPlaceholder: "Select weight classes",
            achievements: "Achievements",
            achievementsPlaceholder: "Enter achievements (max 5000 characters)",
        },
        fighterFormDetails: {
            title: "Fighter Profile Additional Details",
            subtitle: "Complete your fighter profile details",
            team: "Team",
            teamPlaceholder: "Enter team",
            gym: "Gym",
            gymPlaceholder: "Enter gym",
            fightStyleDescription: "Fight Style Description",
            fightStyleDescriptionPlaceholder: "Enter fight style description (max 5000 characters)",
        },
        fightHistory: {
            title: "Fight History",
            subtitle: "Enter your fight history details",
        },
        managerForm: {
            title: "Manager Profile Details",
            subtitle: "Complete your manager profile",
            managerType: "Manager Type",
            managerTypePlaceholder: "Select manager type",
            organizationName: "Organization Name",
            organizationNamePlaceholder: "Enter organization name",
        },
        videoUpload: {
            title: "Upload Video and YouTube Links",
            subtitle: "Upload a single video and add YouTube links to showcase your skills (optional)",
            youtubeOnlyTitle: "YouTube Links",
            youtubeOnlySubtitle: "Add YouTube links to showcase your skills (optional)",
            uploadLabel: "Upload Video",
            uploadDescription: "MP4, MOV (max 50MB)",
            removeVideo: "Remove Video",
            youTubeLinks: "YouTube Links (Optional)",
            youTubeLink: "YouTube Link",
            youTubeLinkPlaceholder: "Enter YouTube link",
            shortTitle: "Short Title",
            shortTitlePlaceholder: "Enter short title",
            shortDescription: "Short Description",
            shortDescriptionPlaceholder: "Enter short description (max 200 characters)",
            removeLink: "Remove Link",
            addLink: "Add YouTube Link",
        },
        sponsor: {
            title: "Sponsors",
            subtitle: "Add your sponsors details including logo, name, description, and website",
            sectionTitle: "Sponsors",
            nameLabel: "Sponsor Name",
            namePlaceholder: "Enter sponsor name",
            nameRequired: "Sponsor Name is required",
            descriptionLabel: "Sponsor Description",
            descriptionPlaceholder: "Enter sponsor description",
            companyUrl: "Company Website",
            companyUrlPlaceholder: "Enter company website",
            uploadLogo: "Upload Sponsor Logo",
            logoDescription: "PNG, JPG (max 2MB)",
            addSponsor: "Add Sponsor",
            removeSponsor: "Remove Sponsor",
            sponsorLimitReached: "Maximum of 5 sponsors allowed",
            invalidUrl: "Enter a valid URL",

        },
        navigation: {
            back: "Back",
            next: "Next",
            submit: "Submit",
            submitting: "Submitting...",
        },
        errorModal: {
            title: "Error",
            close: "Close",
        },
        loading: {
            message: "Loading your dashboard...",
        },
        validation: {
            email: {
                required: "Email is required",
                invalid: "Enter a valid email address",
            },
            password: {
                required: "Password is required",
                invalid: "Password must be 8-100 characters, including one uppercase, one lowercase, one digit, and one special character",
            },
            phone: {
                required: "Phone number is required",
                invalid: "Enter a valid phone number (7-15 digits)",
            },
            socialMediaLink: {
                type: {
                    required: "Social media platform is required",
                    invalid: "Invalid social media platform",
                },
                url: {
                    required: "Social media URL is required",
                    invalid: "Enter a valid URL",
                },
            },
            firstName: {
                required: "First name is required",
            },
            lastName: {
                required: "Last name is required",
            },
            dateOfBirth: {
                required: "Date of birth is required",
                invalid: "Date of birth cannot be in the future",
                tooYoung: "You must be at least 18 years old",
            },
            nationality: {
                required: "Nationality is required",
            },
            country: {
                required: "Country is required",
            },
            region: {
                required: "Region is required",
            },
            height: {
                required: "Height is required",
                invalid: "Height must be positive",
            },
            weight: {
                required: "Weight is required",
                invalid: "Weight must be positive",
            },
            reach: {
                required: "Reach is required",
                invalid: "Reach must be positive",
            },
            stance: {
                required: "Stance is required",
            },
            achievements: {
                required: "Achievements are required",
                maxLength: "Achievements cannot exceed 5000 characters",
            },
            fightStyleDescription: {
                required: "Fight style description is required",
                maxLength: "Description cannot exceed 5000 characters",
            },
            managerType: {
                required: "Manager type is required",
            },
            organizationName: {
                required: "Organization name is required",
            },
            bio: {
                maxLength: "Bio cannot exceed 1000 characters",
            },
            profileImageFile: {
                invalidType: "Only PNG or JPG images are allowed",
                maxSize: "Image size must not exceed 2MB",
                required: "Profile image is required"
            },
            videoFile: {
                invalidType: "Only MP4 or MOV videos are allowed",
                maxSize: "Video size must not exceed 50MB",
            },
            trainingDisciplines: {
                required: "At least one competing in disciplines is required",
            },
            weightClasses: {
                required: "At least one weight class is required",
            },
            youTubeLink: {
                invalid: "Enter a valid YouTube URL",
                maxLength: "Description cannot exceed 200 characters",
            },
        },
        errors: {
            generic: "An error occurred. Please try again.",
            emailExists: "Email already exists. Please log in with your existing account.",
            authenticationFailed: "Authentication failed. Please try again.",
            loginFailed: "Login failed. Please try again.",
        },
        success: {
            title: "Success",
            accountCreated: "Your account was created successfully.",
        },
        addAchievement: '+ Add Achievement',
        remove: 'Remove',
    },
    de: {

        valid_height_required: "Gültige Größe ist erforderlich",
        valid_weight_required: "Gültiges Gewicht ist erforderlich",
        valid_reach_required: "Gültige Reichweite ist erforderlich",
        mainProfileImageTitle: 'Zeigt Ihr Hauptprofilbild an, das für andere Benutzer sichtbar ist.',
        mainProfileImageDescription: 'Ein klares, professionelles Foto hilft, Vertrauen und Wiedererkennung aufzubauen.',

        fightRecordTitle: 'Zeigt Ihre Kampfbilanz – Siege, Niederlagen und Unentschieden – in offiziellen oder halb-offiziellen Kämpfen an.',
        fightRecordDescription: 'Nützlich für Glaubwürdigkeit, Matchmaking und zur Präsentation von Erfahrung.',

        keyVideoTitle: 'Zeigt ein Schlüsselfideo, das Sie repräsentiert – wie z. B. ein Highlight, Promo oder Vorstellungsvideo.',
        keyVideoDescription: 'Wird verwendet, um Ihren Stil, Ihre Fähigkeiten oder Persönlichkeit zu präsentieren.',

        youtubeLinksTitle: 'Fügen Sie Links zu Ihren YouTube-Videos hinzu.',
        youtubeLinksDescription: 'Dadurch können andere Ihre hochgeladenen Inhalte direkt von Ihrem Profil aus ansehen.',

        sponsorsTitle: 'Präsentieren Sie Ihre Sponsoren.',
        sponsorsDescription: 'Das Hinzufügen von Sponsorendetails hebt die Marken hervor, die Sie unterstützen, und erhöht deren Sichtbarkeit.',
        socialMediaPublic: 'Zeigt Ihre öffentlichen Social-Media-Profile an.',
        socialMediaDescription: 'Hilft anderen, sich mit Ihnen zu verbinden, Ihre Aktivitäten zu sehen und Ihre Präsenz in der Kampfsportwelt zu bestätigen.',
        addAchievement: '+ Erfolg hinzufügen',
        remove: 'Entfernen',
        welcome: {
            title: "Ihre Reise beginnt",
            subtitle: "Wählen Sie Ihre Rolle, um fortzufahren",
        },

        successModal: {
            title: "Registrierung erfolgreich",
            messageActive: "Ihr Konto wurde erfolgreich registriert.",
            messageInactive: "Ihr Konto wurde erfolgreich registriert. Ihr Konto ist jedoch inaktiv. Bitte wenden Sie sich an Ihren Administrator, um es zu aktivieren."
        },
        journey: {
            title: "Ihre Reise beginnt",
            roleSelection: "Wählen Sie Ihre Rolle, um zu beginnen.",
            personalDetails: "Geben Sie Ihre persönlichen Daten ein, um Ihr Profil zu erstellen.",
            locationDetails: "Geben Sie Ihre Standortdaten an, um Ihr Profil zu vervollständigen.",
            contactDetails: "Fügen Sie Ihre Kontaktinformationen hinzu, um verbunden zu bleiben.",
            profileImageUpload: "Laden Sie ein Profilbild hoch, um Ihr Konto zu personalisieren.",
            fighterForm: "Vervollständigen Sie Ihre Kämpferdetails, um Ihre Fähigkeiten zu präsentieren.",
            fightHistory: "Fügen Sie Ihre Kampfhistorie hinzu, um Ihre Erfahrung hervorzuheben (optional).",
            managerForm: "Vervollständigen Sie Ihre Managerdetails, um Ihre Organisation aufzubauen.",
            videoUpload: "Laden Sie ein Video und YouTube-Links hoch, um Ihre Fähigkeiten zu präsentieren.",
        },
        roles: {
            fighter: {
                title: "Kämpfer",
                description: "Erstellen Sie Ihr Kämpferprofil und präsentieren Sie Ihre Fähigkeiten",
            },
            manager: {
                title: "Manager",
                description: "Verwalten Sie Kämpfer und bauen Sie Ihre Organisation auf",
            },
            organization: {
                title: "Organisation",
                description: "Vollständige Plattform zur Organisationsverwaltung",
            },
        },
        personalDetails: {
            title: "Personal Details",
            subtitle: "Enter your personal information",
            firstName: "First Name",
            firstNamePlaceholder: "Enter first name",
            lastName: "Last Name",
            lastNamePlaceholder: "Enter last name",
            nickname: "Nickname",
            nicknamePlaceholder: "Enter nickname",
            dateOfBirth: "Date of Birth",
            gender: "Gender",
            genderPlaceholder: "Select your gender",
            male: "Male",
            female: "Female",
            other: "Other"
        },
        locationDetails: {
            title: "Standortdaten",
            subtitle: "Wählen Sie Ihr Land und Ihre Region aus",
            nationality: "Nationalität",
            nationalityPlaceholder: "Nationalität auswählen",
            country: "Wohnsitzland",
            countryPlaceholder: "Land auswählen",
            region: "Region",
            regionPlaceholder: "Region auswählen",
        },
        contactDetails: {
            title: "Kontaktdaten",
            subtitle: "Geben Sie Ihre Kontaktinformationen an",
            email: "E-Mail",
            emailPlaceholder: "E-Mail eingeben",
            phone: "Telefon",
            phonePlaceholder: "Telefonnummer eingeben",
            bio: "Biografie",
            bioPlaceholder: "Biografie eingeben (max. 1000 Zeichen)",
            socialMediaLinks: "Social-Media-Links (optional)",
            addSocialMediaLink: "Social-Media-Link hinzufügen",
            removeSocialMediaLink: "Link entfernen",
            socialMediaPlatform: "Soziale Medien Plattform",
            socialMediaPlatformPlaceholder: "Plattform auswählen",
            socialMediaUrl: "URL",
            socialMediaUrlPlaceholder: "URL eingeben"
        },
        profileImageUpload: {
            title: "Profilbild",
            subtitle: "Laden oder aktualisieren Sie Ihr Profilfoto",
            uploadLabel: "Profilbild hochladen",
            uploadDescription: "PNG, JPG (max. 2MB)",
            viewFullImage: "Vollständiges Bild ansehen",
        },
        fighterFormBasic: {
            title: "Grundlegende Kämpferprofil-Details",
            subtitle: "Geben Sie Ihre grundlegenden Kämpfermetriken ein",
            height: "Größe",
            heightPlaceholder: "Größe eingeben",
            heightUnit: "Einheit",
            weight: "Gewicht",
            weightPlaceholder: "Gewicht eingeben",
            weightUnit: "Einheit",
            reach: "Reichweite",
            reachPlaceholder: "Reichweite eingeben",
            reachUnit: "Einheit",
            stance: "Kampfhaltung",
            stancePlaceholder: "Kampfhaltung auswählen",
            titleHolder: "Titelträger",
            yes: "Ja",
            no: "Nein",
            trainingDisciplines: "Wettkampfdisziplinen",
            trainingDisciplinesPlaceholder: "Wettkampfdisziplinen auswählen",
            weightClasses: "Gewichtsklassen",
            weightClassesPlaceholder: "Gewichtsklassen auswählen",
            achievements: "Erfolge",
            achievementsPlaceholder: "Erfolge eingeben (max. 5000 Zeichen)",
        },
        fighterFormDetails: {
            title: "Zusätzliche Kämpferprofil-Details",
            subtitle: "Vervollständigen Sie Ihre Kämpferprofil-Details",
            team: "Team",
            teamPlaceholder: "Team eingeben",
            gym: "Fitnessstudio",
            gymPlaceholder: "Fitnessstudio eingeben",
            fightStyleDescription: "Beschreibung des Kampfstils",
            fightStyleDescriptionPlaceholder: "Beschreibung des Kampfstils eingeben (max. 5000 Zeichen)",
        },
        fightHistory: {
            title: "Kampfhistorie",
            subtitle: "Geben Sie Ihre Kampfhistorie-Details ein",
        },
        managerForm: {
            title: "Managerprofil-Details",
            subtitle: "Vervollständigen Sie Ihr Managerprofil",
            managerType: "Manager-Typ",
            managerTypePlaceholder: "Manager-Typ auswählen",
            organizationName: "Organisationsname",
            organizationNamePlaceholder: "Organisationsname eingeben",
        },
        videoUpload: {
            title: "Video und YouTube-Links hochladen",
            subtitle: "Laden Sie ein einzelnes Video hoch und fügen Sie optional YouTube-Links hinzu, um Ihre Fähigkeiten zu zeigen",
            youtubeOnlyTitle: "YouTube-Links",
            youtubeOnlySubtitle: "Fügen Sie YouTube-Links hinzu, um Ihre Fähigkeiten zu zeigen (optional)",
            uploadLabel: "Video hochladen",
            uploadDescription: "MP4, MOV (max. 50MB)",
            removeVideo: "Video entfernen",
            youTubeLinks: "YouTube-Links (optional)",
            youTubeLink: "YouTube-Link",
            youTubeLinkPlaceholder: "YouTube-Link eingeben",
            shortTitle: "Kurzer Titel",
            shortTitlePlaceholder: "Kurzen Titel eingeben",
            shortDescription: "Kurze Beschreibung",
            shortDescriptionPlaceholder: "Kurze Beschreibung eingeben (max. 200 Zeichen)",
            removeLink: "Link entfernen",
            addLink: "YouTube-Link hinzufügen",
        },
        sponsor: {
            title: "Sponsoren",
            subtitle: "Fügen Sie Details Ihrer Sponsoren hinzu, einschließlich Logo, Name, Beschreibung und Webseite",
            sectionTitle: "Sponsoren",
            nameLabel: "Sponsorname",
            namePlaceholder: "Sponsorname eingeben",
            nameRequired: "Sponsorname ist erforderlich",
            descriptionLabel: "Sponsorbeschreibung",
            descriptionPlaceholder: "Beschreibung des Sponsors eingeben",
            companyUrl: "Firmenwebseite",
            companyUrlPlaceholder: "Firmenwebseite eingeben",
            uploadLogo: "Sponsorlogo hochladen",
            logoDescription: "PNG, JPG (max. 2MB)",
            addSponsor: "Sponsor hinzufügen",
            removeSponsor: "Sponsor entfernen",
            sponsorLimitReached: "Maximal 5 Sponsoren erlaubt",
            invalidUrl: "Geben Sie eine gültige URL ein",
        },
        navigation: {
            back: "Zurück",
            next: "Weiter",
            submit: "Absenden",
            submitting: "Wird gesendet...",
        },
        errorModal: {
            title: "Fehler",
            close: "Schließen",
        },
        loading: {
            message: "Ihr Dashboard wird geladen...",
        },
        validation: {
            email: {
                required: "E-Mail ist erforderlich",
                invalid: "Geben Sie eine gültige E-Mail-Adresse ein",
            },
            password: {
                required: "Passwort ist erforderlich",
                invalid: "Passwort muss 8-100 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten",
            },
            phone: {
                required: "Telefonnummer ist erforderlich",
                invalid: "Geben Sie eine gültige Telefonnummer ein (7-15 Ziffern)",
            },
            socialMediaLink: {
                type: {
                    required: "Social-Media-Plattform ist erforderlich",
                    invalid: "Ungültige Social-Media-Plattform",
                },
                url: {
                    required: "Social-Media-URL ist erforderlich",
                    invalid: "Geben Sie eine gültige URL ein",
                },
            },
            firstName: {
                required: "Vorname ist erforderlich",
            },
            lastName: {
                required: "Nachname ist erforderlich",
            },
            dateOfBirth: {
                required: "Geburtsdatum ist erforderlich",
                invalid: "Geburtsdatum darf nicht in der Zukunft liegen",
                tooYoung: "Sie müssen mindestens 18 Jahre alt sein",
            },
            nationality: {
                required: "Nationalität ist erforderlich",
            },
            country: {
                required: "Land ist erforderlich",
            },
            region: {
                required: "Region ist erforderlich",
            },
            height: {
                required: "Größe ist erforderlich",
                invalid: "Größe muss positiv sein",
            },
            weight: {
                required: "Gewicht ist erforderlich",
                invalid: "Gewicht muss positiv sein",
            },
            reach: {
                required: "Reichweite ist erforderlich",
                invalid: "Reichweite muss positiv sein",
            },
            stance: {
                required: "Kampfhaltung ist erforderlich",
            },
            achievements: {
                required: "Erfolge sind erforderlich",
                maxLength: "Erfolge dürfen 5000 Zeichen nicht überschreiten",
            },
            fightStyleDescription: {
                required: "Beschreibung des Kampfstils ist erforderlich",
                maxLength: "Beschreibung darf 5000 Zeichen nicht überschreiten",
            },
            managerType: {
                required: "Manager-Typ ist erforderlich",
            },
            organizationName: {
                required: "Organisationsname ist erforderlich",
            },
            bio: {
                maxLength: "Biografie darf 1000 Zeichen nicht überschreiten",
            },
            profileImageFile: {
                invalidType: "Nur PNG- oder JPG-Bilder sind erlaubt",
                maxSize: "Bildgröße darf 2MB nicht überschreiten",
                required: 'Profilbild ist erforderlich'
            },
            videoFile: {
                invalidType: "Nur MP4- oder MOV-Videos sind erlaubt",
                maxSize: "Videogröße darf 50MB nicht überschreiten",
            },
            trainingDisciplines: {
                required: "Mindestens eine Wettkampfdisziplin ist erforderlich",
            },
            weightClasses: {
                required: "Mindestens eine Gewichtsklasse ist erforderlich",
            },
            youTubeLink: {
                invalid: "Geben Sie eine gültige YouTube-URL ein",
                maxLength: "Beschreibung darf 200 Zeichen nicht überschreiten",
            },
        },
        errors: {
            generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
            emailExists: "E-Mail existiert bereits. Bitte melden Sie sich mit Ihrem bestehenden Konto an.",
            authenticationFailed: "Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
            loginFailed: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        },
        success: {
            title: "Erfolg",
            accountCreated: "Ihr Konto wurde erfolgreich erstellt.",
        },
    },
    hr: {
        valid_height_required: "Potrebna je valjana visina",
        valid_weight_required: "Potrebna je valjana težina",
        valid_reach_required: "Potreban je valjani doseg",
        mainProfileImageTitle: 'Prikazuje vašu glavnu profilnu sliku vidljivu drugim korisnicima.',
        mainProfileImageDescription: 'Jasna, profesionalna fotografija pomaže izgraditi povjerenje i prepoznatljivost.',

        fightRecordTitle: 'Prikazuje vaš borbeni omjer — pobjede, poraze i neriješene mečeve — u službenim ili poluslužbenim borbama.',
        fightRecordDescription: 'Korisno za vjerodostojnost, pronalaženje protivnika i prikazivanje iskustva.',

        keyVideoTitle: 'Prikazuje ključni video koji vas predstavlja — poput istaknutih trenutaka borbe, promo videa ili predstavljanja.',
        keyVideoDescription: 'Koristi se za prikazivanje vašeg stila, vještina ili osobnosti.',

        youtubeLinksTitle: 'Dodajte poveznice na svoje YouTube videozapise.',
        youtubeLinksDescription: 'Omogućuje drugima da gledaju vaš preneseni sadržaj izravno s vašeg profila.',

        sponsorsTitle: 'Predstavite svoje sponzore.',
        sponsorsDescription: 'Dodavanje informacija o sponzorima ističe brendove koji vas podržavaju i povećava njihovu vidljivost.',
        socialMediaPublic: 'Prikazuje vaše javne profile na društvenim mrežama.',
        socialMediaDescription: 'Pomaže drugima da se povežu s vama, vide vašu aktivnost i potvrde vašu prisutnost u svijetu borilačkih sportova.',
        addAchievement: '+ Dodaj postignuće',
        remove: 'Ukloni',
        welcome: {
            title: "Vaše putovanje počinje",
            subtitle: "Odaberite svoju ulogu za nastavak"
        },

        successModal: {
            title: "Uspješna registracija",
            messageActive: "Vaš račun je uspješno registriran.",
            messageInactive: "Vaš račun je uspješno registriran. Međutim, vaš račun je neaktivan. Obratite se svom administratoru kako biste ga aktivirali."
        },

        journey: {
            title: "Vaše putovanje počinje",
            roleSelection: "Odaberite svoju ulogu za početak.",
            personalDetails: "Navedite svoje osobne podatke kako biste započeli izgradnju svog profila.",
            locationDetails: "Navedite podatke o lokaciji kako biste dovršili svoj profil.",
            contactDetails: "Dodajte svoje kontaktne podatke kako biste ostali povezani.",
            profileImageUpload: "Učitajte sliku profila kako biste personalizirali svoj račun.",
            fighterForm: "Ispunite podatke o borcu kako biste istaknuli svoje vještine.",
            fightHistory: "Dodajte povijest borbi kako biste istaknuli svoje iskustvo (opcionalno).",
            managerForm: "Ispunite podatke o menadžeru kako biste započeli izgradnju svoje organizacije.",
            videoUpload: "Učitajte video i YouTube poveznice kako biste istaknuli svoje vještine.",
            socialMediaPlatform: "Platforma društvenih medija",
            socialMediaPlatformPlaceholder: "Odaberite platformu",
            socialMediaUrl: "URL",
            socialMediaUrlPlaceholder: "Unesite URL za {platform}"
        },

        roles: {
            fighter: {
                title: "Borač",
                description: "Kreirajte svoj profil borca i istaknite svoje vještine"
            },
            manager: {
                title: "Menadžer",
                description: "Upravljajte borcima i gradite svoju organizaciju"
            },
            organization: {
                title: "Organizacija",
                description: "Sveobuhvatna platforma za upravljanje organizacijom"
            }
        },

        personalDetails: {
            title: "Persönliche Daten",
            subtitle: "Geben Sie Ihre persönlichen Informationen ein",
            firstName: "Vorname",
            firstNamePlaceholder: "Vorname eingeben",
            lastName: "Nachname",
            lastNamePlaceholder: "Nachname eingeben",
            nickname: "Spitzname",
            nicknamePlaceholder: "Spitzname eingeben",
            dateOfBirth: "Geburtsdatum",
            gender: "Geschlecht",
            genderPlaceholder: "Wähle dein Geschlecht",
            male: "Männlich",
            female: "Weiblich",
            other: "Andere"
        },


        locationDetails: {
            title: "Podaci o lokaciji",
            subtitle: "Odaberite svoju zemlju i regiju",
            nationality: "Nacionalnost",
            nationalityPlaceholder: "Odaberite nacionalnost",
            country: "Zemlja prebivališta",
            countryPlaceholder: "Odaberite zemlju",
            region: "Regija",
            regionPlaceholder: "Odaberite regiju"
        },

        contactDetails: {
            title: "Kontakt podaci",
            subtitle: "Navedite svoje kontakt podatke",
            email: "E-pošta",
            emailPlaceholder: "Unesite e-poštu",
            phone: "Telefon",
            phonePlaceholder: "Unesite broj telefona",
            bio: "Biografija",
            bioPlaceholder: "Unesite biografiju (maks. 1000 znakova)",
            socialMediaLinks: "Poveznice društvenih medija (opcionalno)",
            addSocialMediaLink: "Dodaj poveznicu društvenih medija",
            removeSocialMediaLink: "Ukloni poveznicu",
            socialMediaPlatform: "Platforma društvenih medija",
            socialMediaPlatformPlaceholder: "Odaberite platformu",
            socialMediaUrl: "URL",
            socialMediaUrlPlaceholder: "Unesite URL"
        },

        profileImageUpload: {
            title: "Slika profila",
            subtitle: "Učitajte ili ažurirajte svoju profilnu sliku",
            uploadLabel: "Učitaj sliku profila",
            uploadDescription: "PNG, JPG (maks. 2MB)",
            viewFullImage: "Pogledaj cijelu sliku"
        },

        fighterFormBasic: {
            title: "Osnovni podaci profila borca",
            subtitle: "Unesite osnovne metrike borca",
            height: "Visina",
            heightPlaceholder: "Unesite visinu",
            heightUnit: "Jedinica",
            weight: "Težina",
            weightPlaceholder: "Unesite težinu",
            weightUnit: "Jedinica",
            reach: "Domet",
            reachPlaceholder: "Unesite domet",
            reachUnit: "Jedinica",
            stance: "Stav",
            stancePlaceholder: "Odaberite stav",
            titleHolder: "Nositelj titule",
            yes: "Da",
            no: "Ne",
            trainingDisciplines: "Natjecateljske discipline",
            trainingDisciplinesPlaceholder: "Odaberite natjecateljske discipline",
            weightClasses: "Težinske kategorije",
            weightClassesPlaceholder: "Odaberite težinske kategorije",
            achievements: "Postignuća",
            achievementsPlaceholder: "Unesite postignuća (maks. 5000 znakova)"
        },

        fighterFormDetails: {
            title: "Dodatni podaci profila borca",
            subtitle: "Dovršite podatke svog profila borca",
            team: "Tim",
            teamPlaceholder: "Unesite tim",
            gym: "Teretana",
            gymPlaceholder: "Unesite teretanu",
            fightStyleDescription: "Opis stila borbe",
            fightStyleDescriptionPlaceholder: "Unesite opis stila borbe (maks. 5000 znakova)"
        },

        fightHistory: {
            title: "Povijest borbi",
            subtitle: "Unesite podatke o svojoj povijesti borbi"
        },

        managerForm: {
            title: "Podaci profila menadžera",
            subtitle: "Dovršite svoj profil menadžera",
            managerType: "Vrsta menadžera",
            managerTypePlaceholder: "Odaberite vrstu menadžera",
            organizationName: "Naziv organizacije",
            organizationNamePlaceholder: "Unesite naziv organizacije"
        },

        videoUpload: {
            title: "Otpremi video i YouTube linkove",
            subtitle: "Otpremite jedan video i dodajte YouTube linkove za prikaz svojih vještina (opcionalno)",
            youtubeOnlyTitle: "YouTube linkovi",
            youtubeOnlySubtitle: "Dodajte YouTube linkove za prikaz svojih vještina (opcionalno)",
            uploadLabel: "Otpremi video",
            uploadDescription: "MP4, MOV (maks. 50MB)",
            removeVideo: "Ukloni video",
            youTubeLinks: "YouTube linkovi (opcionalno)",
            youTubeLink: "YouTube link",
            youTubeLinkPlaceholder: "Unesite YouTube link",
            shortTitle: "Kratki naslov",
            shortTitlePlaceholder: "Unesite kratak naslov",
            shortDescription: "Kratki opis",
            shortDescriptionPlaceholder: "Unesite kratak opis (maks. 200 znakova)",
            removeLink: "Ukloni link",
            addLink: "Dodaj YouTube link",
        },
        sponsor: {
            title: "Sponzori",
            subtitle: "Dodajte podatke svojih sponzora uključujući logo, ime, opis i web stranicu",
            sectionTitle: "Sponzori",
            nameLabel: "Ime sponzora",
            namePlaceholder: "Unesite ime sponzora",
            nameRequired: "Ime sponzora je obavezno",
            descriptionLabel: "Opis sponzora",
            descriptionPlaceholder: "Unesite opis sponzora",
            companyUrl: "Web stranica tvrtke",
            companyUrlPlaceholder: "Unesite web stranicu tvrtke",
            uploadLogo: "Otpremi logo sponzora",
            logoDescription: "PNG, JPG (maks. 2MB)",
            addSponsor: "Dodaj sponzora",
            removeSponsor: "Ukloni sponzora",
            sponsorLimitReached: "Dozvoljeno maksimalno 5 sponzora",
            invalidUrl: "Unesite valjani URL",
        },

        navigation: {
            back: "Natrag",
            next: "Dalje",
            submit: "Pošalji",
            submitting: "Slanje u tijeku..."
        },

        errorModal: {
            title: "Pogreška",
            close: "Zatvori"
        },

        loading: {
            message: "Učitavanje vaše nadzorne ploče..."
        },

        validation: {
            email: {
                required: "E-pošta je obavezna",
                invalid: "Unesite valjanu adresu e-pošte"
            },
            password: {
                required: "Lozinka je obavezna",
                invalid: "Lozinka mora sadržavati 8 do 100 znakova, uključujući jedno veliko slovo, jedno malo slovo, broj i poseban znak"
            },
            phone: {
                required: "Broj telefona je obavezan",
                invalid: "Unesite valjan broj telefona (7-15 znamenki)"
            },
            socialMediaLink: {
                type: {
                    required: "Platforma društvenih medija je obavezna",
                    invalid: "Nevaljana platforma društvenih medija"
                },
                url: {
                    required: "URL društvenih medija je obavezan",
                    invalid: "Unesite valjanu URL adresu"
                }
            },
            firstName: {
                required: "Ime je obavezno"
            },
            lastName: {
                required: "Prezime je obavezno"
            },
            dateOfBirth: {
                required: "Datum rođenja je obavezan",
                invalid: "Datum rođenja ne može biti u budućnosti",
                tooYoung: "Morate imati najmanje 18 godina"
            },
            nationality: {
                required: "Nacionalnost je obavezna"
            },
            country: {
                required: "Zemlja je obavezna"
            },
            region: {
                required: "Regija je obavezna"
            },
            height: {
                required: "Visina je obavezna",
                invalid: "Visina mora biti pozitivna"
            },
            weight: {
                required: "Težina je obavezna",
                invalid: "Težina mora biti pozitivna"
            },
            reach: {
                required: "Domet je obavezan",
                invalid: "Domet mora biti pozitivan"
            },
            stance: {
                required: "Stav je obavezan"
            },
            achievements: {
                required: "Postignuća su obavezna",
                maxLength: "Postignuća ne smiju prelaziti 5000 znakova"
            },
            fightStyleDescription: {
                required: "Opis stila borbe je obavezan",
                maxLength: "Opis ne smije prelaziti 5000 znakova"
            },
            managerType: {
                required: "Vrsta menadžera je obavezna"
            },
            organizationName: {
                required: "Naziv organizacije je obavezan"
            },
            bio: {
                maxLength: "Biografija ne smije prelaziti 1000 znakova"
            },
            profileImageFile: {
                invalidType: "Dozvoljene su samo PNG ili JPG slike",
                maxSize: "Veličina slike ne smije prelaziti 2 MB",
                required: "Slika profila je obavezna"
            },
            videoFile: {
                invalidType: "Dozvoljeni su samo MP4 ili MOV videozapisi",
                maxSize: "Veličina videozapisa ne smije prelaziti 50 MB"
            },
            trainingDisciplines: {
                required: "Potrebna je najmanje jedna natjecateljska disciplina"
            },
            weightClasses: {
                required: "Potrebna je najmanje jedna težinska kategorija"
            },
            youTubeLink: {
                invalid: "Unesite valjanu YouTube URL adresu",
                maxLength: "Opis ne smije prelaziti 200 znakova"
            }
        },

        errors: {
            generic: "Došlo je do pogreške. Molimo pokušajte ponovno.",
            emailExists: "E-pošta već postoji. Molimo prijavite se s postojećim računom.",
            authenticationFailed: "Autentikacija nije uspjela. Molimo pokušajte ponovno.",
            loginFailed: "Prijava nije uspjela. Molimo pokušajte ponovno."
        },

        success: {
            title: "Uspjeh",
            accountCreated: "Vaš račun je uspješno kreiran."
        }
    }
};